// Visning av biler: etiketter, dager til EU-kontroll og tilgjengelighet.
// vehicleAvailability speiler isVehicleAssignable i functions/src/orgVehicles.js.

export const BODY_TYPE_LABEL = {
  tipper: 'Tippbil', box: 'Skapbil', semi: 'Semi', flatbed: 'Planbil', crane: 'Kranbil', other: 'Annet',
};
export const FUEL_LABEL = { diesel: 'Diesel', gas: 'Gass', electric: 'Elbil', hybrid: 'Hybrid' };

// Dagens dato i Oslo som YYYY-MM-DD (sv-SE gir ISO-format)
export function todayIso(now = new Date()) {
  return new Intl.DateTimeFormat('sv-SE', { timeZone: 'Europe/Oslo' }).format(now);
}

export function daysUntil(iso, now = new Date()) {
  return Math.round((Date.parse(`${iso}T00:00:00Z`) - Date.parse(`${todayIso(now)}T00:00:00Z`)) / 86400000);
}

const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;

// tone: 'ok' | 'soon' (30 dager eller mindre) | 'expired' | 'none'
function dueStatus(date, now) {
  if (!date) return { tone: 'none', label: 'Ikke registrert', days: null };
  const days = daysUntil(date, now);
  if (days < 0) return { tone: 'expired', label: `Utløpt for ${plural(-days, 'dag', 'dager')} siden`, days };
  if (days === 0) return { tone: 'soon', label: 'I dag', days };
  if (days <= 30) return { tone: 'soon', label: `Om ${plural(days, 'dag', 'dager')}`, days };
  return { tone: 'ok', label: date, days };
}

export const inspectionStatus = (vehicle, now = new Date()) => dueStatus(vehicle?.nextInspectionDate, now);
export const serviceStatus = (vehicle, now = new Date()) => dueStatus(vehicle?.nextServiceDate, now);

export function vehicleAvailability(vehicle, now = new Date()) {
  if (vehicle?.status === 'out_of_service') return { ok: false, reason: 'out_of_service', label: 'Ute av drift' };
  const today = todayIso(now);
  const expired = !vehicle?.nextInspectionDate || vehicle.nextInspectionDate < today;
  const overridden = Boolean(vehicle?.inspectionOverrideUntil) && vehicle.inspectionOverrideUntil >= today;
  if (expired && overridden) return { ok: true, label: 'Tilgjengelig (overstyrt EU-kontroll)' };
  if (expired) return { ok: false, reason: 'inspection_expired', label: 'EU-kontroll utløpt' };
  return { ok: true, label: 'Tilgjengelig' };
}
